export default __webpack_public_path__ + "1a80b00955cb7cf1abfb5c4d874d6f48.png";